<template>
  <div class="botao">
    <button @click="voltar()">
      <i class="fas fa-arrow-left"/>
    </button>
  </div>
</template>
<script>
  export default {
    props: {
      nomeRota: {
        type: String
      },
      params: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      voltar() {
        if (this.nomeRota) {
          this.$router.push({ name: this.nomeRota, params: this.params });
          return;
        }
        if (this.$router.pagina_anterior == "CessaoEdit" ||
            this.$router.pagina_anterior == "DisposicaoEdit" ||
            this.$router.pagina_anterior == "ServidorEdit" ||
            this.$router.pagina_anterior == "ConveniosCotasEdit" ||
            this.$router.pagina_anterior == "OrgaoEdit" ||
            this.$router.pagina_anterior == "OnusEdit" ||
            this.$router.pagina_anterior == "StatusEdit" ||
            this.$router.pagina_anterior == "CessaoNew" ||
            this.$router.pagina_anterior == "DisposicaoNew" ||
            this.$router.pagina_anterior == "ServidorNew" ||
            this.$router.pagina_anterior == "ConveniosCotasNew" ||
            this.$router.pagina_anterior == "OrgaoNew" ||
            this.$router.pagina_anterior == "OnusNew" ||
            this.$router.pagina_anterior == "StatusNew"
        ) {
          window.history.back(-1);
          window.history.back(-1);
        } else {
          window.history.back();
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
.botao {
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.35rem;
    height: 2.35rem;
    border-radius: 999px;
    border: 1px solid #dde5e0;
    background-color: #ffffff;
    color: #005516;
    box-shadow: 0 1px 2px rgba(15, 40, 25, 0.04);
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease,
      transform 0.15s ease;

    i {
      font-size: 0.95rem;
    }

    &:hover {
      background-color: #f3f8f4;
      border-color: #b9cfc1;
      color: #007a20;
    }

    &:active {
      transform: translateY(1px);
    }
  }
}
</style>
